import HeroSection from './components/HeroSection';
import MissionSection from './components/MissionSection';
import PillarsSection from './components/PillarsSection';
import CommitmentSection from './components/CommitmentSection';
import InnovationSection from './components/InnovationSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <MissionSection />
      <PillarsSection />
      <CommitmentSection />
      <InnovationSection />
      <ContactSection />
    </main>
  );
}